<template>
  <div>
    <van-tag type="success" v-for="item in tags" :key="item.id">{{ item.name }}</van-tag>
  </div>
</template>

<script>
    export default {
      components:{
      },
      props:{
        tags: {
          type: Array
        },
      },
      methods:{

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list-tag.vue